import React, { Component } from "react";
import PropTypes from "prop-types";

export default class TagsWrapper extends Component {
  static contextTypes = {
    disabled: PropTypes.bool,
  };

  static getChildContext = ({ disabled }) => disabled;

  render() {
    return (
      <div
        css={{
          paddingBottom: 5,
          paddingLeft: 5,
          paddingRight: 5,
          boxSizing: "border-box",
          display: "flex",
          alignItems: "center",
          flex: "1 1 auto",
          flexWrap: "wrap",
        }}
        {...this.props}
      />
    );
  }
}
